var th = {
  "Add Quantity Breaks to your product page": "เพิ่มส่วนลดตามจำนวนในหน้าสินค้าของคุณ",
  "Add Upsell.com to your ": "เพิ่ม Upsell.com ไปยัง ",
  "Add to cart click": "คลิกเพิ่มลงตะกร้า",
  "All time": "ตลอดเวลา",
  "and select": "และเลือก",
  "button": "ปุ่ม",
  "Cart drawer page": "หน้าลิ้นชักตะกร้าสินค้า",
  "Cart page": "หน้าตะกร้าสินค้า",
  "Check status": "ตรวจสอบสถานะ",
  "Checkout page": "หน้าชำระเงิน",
  "Checkout click": "คลิกหน้าชำระเงิน",
  "Click": "คลิก",
  "Click on": "คลิก",
  "Click the": "คลิกที่",
  "Custom slot": "สล็อตที่กำหนดเอง",
  "Custom slots": "สล็อตที่กำหนดเอง",
  "Custom Slots": "สล็อตที่กำหนดเอง",
  "Enable in theme editor": "เปิดใช้ในตัวแก้ไขธีม",
  "contact support.": "ติดต่อฝ่ายสนับสนุน",
  "from the right sidebar": "จากแถบด้านขวา",
  "Go to App Embeds": "ไปที่การฝังแอป",
  "Go to your Cart drawer page": "ไปที่หน้าลิ้นชักตะกร้าสินค้าของคุณ",
  "Go to your Cart page": "ไปที่หน้าตะกร้าสินค้าของคุณ",
  "Go to your Checkout page": "ไปที่หน้าชำระเงินของคุณ",
  "Go to your Order status page": "ไปที่หน้าสถานะคำสั่งซื้อของคุณ",
  "Go to your Post purchase page": "ไปที่หน้าหลังการซื้อของคุณ",
  "Go to your Product page": "ไปที่หน้าสินค้าของคุณ",
  "Go to your Thank you page": "ไปที่หน้าขอบคุณของคุณ",
  "items": "รายการ",
  "in the left sidebar": "ในแถบด้านซ้าย",
  "Last 12 months": "12 เดือนที่ผ่านมา",
  "Last 30 days": "30 วันที่ผ่านมา",
  "Last 365 days": "365 วันที่ผ่านมา",
  "Last 7 days": "7 วันที่ผ่านมา",
  "Last 90 days": "90 วันที่ผ่านมา",
  "Last month": "เดือนที่แล้ว",
  "Last year": "ปีที่แล้ว",
  "Make sure": "ตรวจสอบให้แน่ใจว่า",
  "Need assistance? Contact our support team for help.": "ต้องการความช่วยเหลือ? ติดต่อทีมสนับสนุนของเรา",
  "Order status page": "หน้าสถานะคำสั่งซื้อ",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "แอปของเรากำลังปรับปรุงเพื่อเพิ่มประสบการณ์การใช้งานของคุณ",
  "Post purchase page": "หน้าหลังการซื้อ",
  "Product page": "หน้าสินค้า",
  "Save": "บันทึก",
  "Scroll to the bottom and select": "เลื่อนลงไปด้านล่างแล้วเลือก",
  "Select": "เลือก",
  "Success. Please continue.": "สำเร็จ กรุณาดำเนินการต่อ",
  "Thank you page": "หน้าขอบคุณ",
  "The Upsell.com team.": "ทีมงาน Upsell.com",
  "The Upsell.com widget is not placed on ": "วิดเจ็ต Upsell.com ไม่ได้ถูกวางบน ",
  ". Please follow the steps above or ": " กรุณาทำตามขั้นตอนด้านบนหรือ ",
  "Today": "วันนี้",
  "toggle is on": "เปิดใช้งานอยู่",
  "Total": "รวม",
  "under": "ภายใต้",
  "We apologize for any inconvenience caused,": "ขออภัยในความไม่สะดวก,",
  "We apologize for any inconvenience caused.": "ขออภัยในความไม่สะดวก",
  "We'll be done in a few minutes!": "เราจะเสร็จสิ้นในอีกไม่กี่นาที!",
  "We're improving our services!": "เรากำลังปรับปรุงบริการของเรา!",
  "Widget already added": "เพิ่มวิดเจ็ตแล้ว",
  "Yesterday": "เมื่อวาน",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "คุณเปิดใช้งานวิดเจ็ตในร้านค้าออนไลน์ของคุณแล้ว แต่ยังไม่ได้บันทึกในตัวแก้ไข Upsell",
  "You placed the widget on the ": "คุณวางวิดเจ็ตบน ",
  ", but you didn't save it in Shopify editor. Please go back to ": " แต่คุณยังไม่ได้บันทึกใน Shopify editor กรุณากลับไปที่ ",
  " and save the changes.": " และบันทึกการเปลี่ยนแปลง"
};

export { th as default };
//# sourceMappingURL=th.json.js.map
